import type { FC } from 'react';

import { useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { DEPOSIT } from '../../constants';
import { TABS_META } from '../../tabsMeta';

import type { TabType } from '../../types';
import { testIds } from '../../../../core/testIds';
import styles from './SettingsModalFooter.module.css';

const SettingsModalFooter: FC<{
  activeIcon: TabType,
  onSelectTab: (tab: TabType) => void,
  enableDeposit: boolean
}> = ({ activeIcon, onSelectTab, enableDeposit}) => {
  const { t } = useTranslation();
  // Bumped on each deposit click so the green flash re-triggers via a fresh key.
  const [depositFlashKey, setDepositFlashKey] = useState(0);

  const handleSelectTab = useCallback((tab: TabType) => {
    if (tab === DEPOSIT) {
      setDepositFlashKey((key) => key + 1);
    }

    onSelectTab(tab);
  }, [onSelectTab]);

  return <div className={styles.grid}>
    {Object.entries(TABS_META).map(([key, meta]) => {
      const type = key as TabType;
      const isDeposit = type === DEPOSIT;
      const disabled = isDeposit && !enableDeposit ? styles.disabled : '';
      const flash = isDeposit && depositFlashKey > 0 ? styles.flash : '';

      return (
        <button
          key={isDeposit ? `${type}-${depositFlashKey}` : type}
          type="button"
          data-type={type}
          data-testid={testIds.settings.tabButton(type)}
          className={[
            styles.button,
            disabled,
            flash,
            activeIcon === type ? styles.selected : ''
          ].join(' ').trim()}
          onClick={() => handleSelectTab(type)}
        >
          {meta.icon}
          <div className={styles.text}>{t(meta.text, { defaultValue: type }).toUpperCase()}</div>
        </button>
      );
    })}
  </div>
};

export default SettingsModalFooter;
